import React, { useState, useEffect } from "react";

const getSchedules = () => JSON.parse(localStorage.getItem("doctorSchedules")) || [];

const MonthCalendar = () => {
  const [events, setEvents] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());

  // Load schedules and listen for changes
  useEffect(() => {
    const load = () => setEvents(getSchedules());
    load();
    const handler = (e) => {
      if (e.key === "doctorSchedules") load();
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const changeMonth = (offset) => {
    setCurrentMonth((prev) => {
      const newDate = new Date(prev);
      newDate.setMonth(newDate.getMonth() + offset);
      return newDate;
    });
  };

  const daysInMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate();
  const firstDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).getDay();

  const days = [];
  for (let i = 0; i < firstDay; i++) days.push(null);
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), i));
  }

  const isEventDay = (date) => {
    const norm = new Date(date.toDateString());
    return events.some((ev) => {
      const start = new Date(ev.stDate);
      const end = new Date(ev.endDate);
      const s = new Date(start.toDateString());
      const e = new Date(end.toDateString());
      return s <= norm && norm <= e;
    });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-700">
          {currentMonth.toLocaleString("default", { month: "long", year: "numeric" })}
        </h2>
        <div className="flex gap-1">
          <button onClick={() => changeMonth(-1)} className="p-1.5 rounded-full hover:bg-gray-200 transition">
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button onClick={() => changeMonth(1)} className="p-1.5 rounded-full hover:bg-gray-200 transition">
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center">
        {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
          <div key={d} className="text-xs font-semibold text-gray-400 py-1">{d}</div>
        ))}
        {days.map((day, i) => (
          <div
            key={i}
            className={`h-9 flex items-center justify-center text-sm rounded-full transition ${
              day
                ? isEventDay(day)
                  ? "bg-indigo-100 text-indigo-800 font-bold ring-2 ring-indigo-300"
                  : "hover:bg-gray-100 text-gray-700"
                : ""
            }`}
          >
            {day ? day.getDate() : ""}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthCalendar;